module.exports = __webpack_public_path__ + "static/media/TheVendingSuppliersLogo.6544ef08.png";